import { useParams, useLocation, useNavigate } from "react-router-dom";
import { UserGroupForm } from "../../../components/user-group/UserGroupForm";
import { useToast } from "@/hooks/use-toast";
import { useEditUserGroup } from "@/hooks/users/useEditUserGroup";
import LoaderComponent from "@/components/common/LoaderComponent";

const EditUserGroup = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const { toast } = useToast();
  const { userGroup, assignedUserIds, loading, submitting, updateUserGroup } = useEditUserGroup(id || '');

  const handleSubmit = async (data: any) => {
    const payload = {
      userGroupName: data.groupName,
      userIds: data.assignedUsers.map((user: any) => user.id),
    };

    const success = await updateUserGroup(payload);
    
    if (success) {
      // Preserve filters and tab when returning
      const returnParams = location.state?.returnParams || new URLSearchParams(location.search).toString();
      navigate(`/admin/users?${returnParams}`, {
        state: { activeTab: 'user-group' }
      });
    }
  };

  const returnPath = () => {
    const returnParams = location.state?.returnParams || new URLSearchParams(location.search).toString();
    return `/admin/users?${returnParams}`;
  };

  if (loading) {
    return <LoaderComponent />;
  }

  if (!userGroup) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <h2 className="text-2xl font-semibold text-foreground mb-2">User Group Not Found</h2>
          <p className="text-muted-foreground mb-4">The requested user group could not be found.</p>
          <button
            onClick={() => navigate('/admin/users')}
            className="text-primary hover:underline"
          >
            Return to Users
          </button>
        </div>
      </div>
    );
  }

  const initialData = {
    groupName: userGroup.user_group_name,
    assignedUserIds: assignedUserIds,
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3 px-6 pt-6">
        <h1 className="text-2xl font-semibold text-foreground">Edit User Group</h1>
      </div>
      <UserGroupForm
        title=""
        initialData={initialData}
        onSubmit={handleSubmit}
        returnPath={returnPath()}
        existingGroupId={Number(id)}
        isSubmitting={submitting}
      />
    </div>
  );
};

export default EditUserGroup;